import { useState, useEffect } from 'react';
import { getCampaignCalloutsByLocale } from './src-utils-index.js';
import { usePersistedData } from './src-hooks-usePersistedData.js';
import * as reader from '@vp/ab-reader';
import usePricingContextInitialization from './src-hooks-usePricingContextInitialization.js';

const useCampaignCallouts = (tenant, locale, previewDate, id) => {
  const [isLoading, setIsLoading] = useState(false);
  const calloutsCacheKey = `campaign_callouts_campaigns_${tenant?.toLowerCase() ?? ""}_${locale?.toLowerCase() ?? ""}_${previewDate ?? ""}`;
  usePricingContextInitialization(tenant, locale);
  const [result] = usePersistedData({
    cacheKey: calloutsCacheKey,
    fetchValue: async (callback) => {
      setIsLoading(true);
      reader.initialize();
      let allExperiments = [];
      await reader.waitTillAvailable(1e3);
      try {
        allExperiments = reader.getAllExperiments();
      } catch (err) {
        console.error(
          `Could not get experiments for callout campaigns due to ${err}`
        );
      }
      try {
        const campaignData = await fetchCampaigns(
          allExperiments,
          tenant,
          locale,
          previewDate
        );
        if (previewDate != null && previewDate !== "") {
          campaignData.result.cache = {
            expiredTTL: 1,
            staleTTL: 1
          };
        }
        const newValue = {
          callouts: campaignData.result.callouts,
          skin: campaignData.result.skin
        };
        callback(newValue, campaignData.result.cache);
        if (campaignData.context != null) {
          fireCampaignCalloutsImpression(campaignData.context);
        }
      } catch (err) {
        console.error(`Could not get callout campaigns due to: ${err}`);
      } finally {
        setIsLoading(false);
      }
    },
    id
  });
  useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  }, []);
  return {
    callouts: result?.callouts ?? {},
    skin: result?.skin ?? "",
    isLoading
  };
};
async function fetchCampaigns(allExperiments, tenant, locale, previewDate) {
  let campaigns = {
    result: {
      callouts: {},
      skin: ""
    }
  };
  if (!tenant || !locale) {
    return campaigns;
  }
  campaigns = await getCampaignCalloutsByLocale(
    allExperiments,
    tenant,
    locale,
    previewDate
  );
  return campaigns;
}
async function fireCampaignCalloutsImpression(context) {
  reader.fireImpression(context.experimentKey, context.variationKey);
}

export { useCampaignCallouts };
//# sourceMappingURL=src-hooks-useCampaignCallouts.js.map
